import { ProcessingJobType } from "@prisma/client";
import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { CreditExample } from "@/app/types/billing/CreditExample";
import { Credits, ProcessingPrice } from "@/app/vars/Credits";

export function currentPath(): string {
  if (typeof window === "undefined") {
    return "/";
  }
  return `${window.location.pathname}${window.location.search}`;
}

function creditPerBatch(t: TFn, batch: number, unit: TKey): string {
  return `1 ${t(TKey.CREDITS_PER_UNIT)} / ${batch} ${t(unit)}`;
}

export function creditCost(t: TFn, credits: number, per?: TKey): string {
  const unit = t(credits === 1 ? TKey.CREDITS_PER_UNIT : TKey.CREDITS_LABEL);
  const suffix = per ? ` ${t(per)}` : "";

  return `${credits} ${unit}${suffix}`;
}

export function buildCreditExamples(t: TFn): CreditExample[] {
  return [
    {
      label: t(TKey.CREDITS_EXAMPLE_CALL),
      cost: creditCost(t, Credits.ANALYSIS_CREDITS_PER_HOUR, TKey.CREDITS_EXAMPLE_PER_HOUR),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_OFFER),
      cost: creditCost(t, ProcessingPrice[ProcessingJobType.OFFER_EXTRACTION]),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_AVATAR),
      cost: creditCost(t, ProcessingPrice[ProcessingJobType.CLIENT_AVATAR]),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_CRITERIA),
      cost: creditCost(t, ProcessingPrice[ProcessingJobType.PROSPECT_SEARCH]),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_SEQUENCE),
      cost: creditCost(
        t,
        ProcessingPrice[ProcessingJobType.MESSAGE_SEQUENCE],
        TKey.CREDITS_EXAMPLE_PER_VARIANT,
      ),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_PROSPECT),
      cost: creditCost(t, Credits.EXTENSION_PROFILES_PER_CREDIT, TKey.CREDITS_EXAMPLE_PER_PROSPECT),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_POOL),
      cost: creditPerBatch(t, Credits.POOL_PROFILES_PER_CREDIT, TKey.CREDITS_EXAMPLE_PER_PROFILE),
    },
    {
      label: t(TKey.CREDITS_EXAMPLE_REPLY),
      cost: creditCost(
        t,
        ProcessingPrice[ProcessingJobType.REPLY_SUGGESTION],
        TKey.CREDITS_EXAMPLE_PER_MESSAGE,
      ),
    },
  ];
}
